/* ty-canvas-polyfill (05.10.2026)
 * roundRect לקנבס בדפדפנים ישנים (Safari מתחת ל-iOS 16). ty-show.js מצייר איתו.
 * בדפדפן שיש בו roundRect הקובץ לא עושה כלום.
 * הכלי: shopify-agent/scripts/apply-canvas-polyfill-2026-10-05.mjs */
(function () {
  var C = window.CanvasRenderingContext2D;
  if (!C || C.prototype.roundRect) return;
  C.prototype.roundRect = function (x, y, w, h, r) {
    var rr = Array.isArray(r) ? r[0] : r;
    rr = (rr && typeof rr === 'object') ? (rr.x || 0) : (+rr || 0);
    rr = Math.max(0, Math.min(rr, Math.abs(w) / 2, Math.abs(h) / 2));
    this.moveTo(x + rr, y);
    this.arcTo(x + w, y, x + w, y + h, rr);
    this.arcTo(x + w, y + h, x, y + h, rr);
    this.arcTo(x, y + h, x, y, rr);
    this.arcTo(x, y, x + w, y, rr);
    this.closePath();
    return this;
  };
})();
